function initTestimonialsSliders() {
  if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return;

  window.jQuery('.testmonials-slier').slick({
    infinite: true,
    autoplay: true,
    speed: 700,
    arrows: true,
    dots: true,
    slidesToShow: 2,
    prevArrow: '<div class="class-to-style"><span class=" fa-solid fa-chevron-left"></span></div>',
    nextArrow: ' <div class="class-style"><span class=" fa-solid fa-chevron-right"></span></div>',
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 1, slidesToScroll: 1, infinite: true } },
      { breakpoint: 800, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ]
  });

  window.jQuery('.testmonials-slier2').slick({
    infinite: true,
    autoplay: true,
    speed: 700,
    arrows: true,
    dots: true,
    slidesToShow: 2,
    prevArrow: '<div class="class-to-style"><span class=" fa-solid fa-chevron-left"></span></div>',
    nextArrow: ' <div class="class-style"><span class=" fa-solid fa-chevron-right"></span></div>',
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 1, slidesToScroll: 1, infinite: true } },
      { breakpoint: 800, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ]
  });
}

window.addEventListener('DOMContentLoaded', initTestimonialsSliders);


function myFunction(imgs) {
  var expandImg = document.getElementById("expandedImg");
  var imgText = document.getElementById("imgtext");
  expandImg.src = imgs.src;
  imgText.innerHTML = imgs.alt;
  expandImg.parentElement.style.display = "block";
}





function myFunction(imgs) {
  var expandImg = document.getElementById("expandedImg");
  var imgText = document.getElementById("imgtext");
  expandImg.src = imgs.src;
  imgText.innerHTML = imgs.alt;
  expandImg.parentElement.style.display = "block";
}


      document.addEventListener("DOMContentLoaded", function() {
      var modal = document.getElementById("myModal");
      var btn = document.getElementById("myBtn");
      var span = document.getElementsByClassName("close")[0];

      if (btn && modal) {
        btn.onclick = function() {
          modal.style.display = "block";
        };
      }

      if (span && modal) {
        span.onclick = function() {
          modal.style.display = "none";
        };
      }

      if (modal) {
        window.onclick = function(event) {
          if (event.target === modal) {
            modal.style.display = "none";
          }
        };
      }
    });

    document.addEventListener('DOMContentLoaded', function () {
      var mobileCartTrigger = document.querySelector('.js-header-cart-icon--mobile');
      var desktopCartTrigger = document.querySelector('.js-header-cart-icon--desktop');

      if (!mobileCartTrigger) return;

      mobileCartTrigger.addEventListener('click', function (event) {
        if (window.innerWidth >= 992) return;

        event.preventDefault();
        event.stopPropagation();

        if (desktopCartTrigger) {
          desktopCartTrigger.click();
          return;
        }

        var cartShell = document.querySelector('.header-cart');
        if (cartShell) {
          cartShell.classList.add('active');
          document.body.classList.add('cart-active');
        }

        var cartDrawer = document.querySelector('.dropdown-cart');
        if (cartDrawer) {
          cartDrawer.style.display = 'flex';
        }

        var cartMessage = document.getElementById('cart-message');
        if (cartMessage) {
          cartMessage.classList.add('is-open');
        }
      });
    });
